"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: notification/notification-model.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fnotification%2Fnotification-model.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.channelToJSON = exports.channelFromJSON = exports.NoOpResponse = exports.NoOpRequest = exports.NotificationFilterDateRange = exports.NotificationFilter = exports.Channel = void 0;
const notification_messages_1 = require("./notification-messages");
const protobufPackage = 'com.step.notification.proto';
var Channel;
(function (Channel) {
    Channel["INVALID_CHANNEL"] = "INVALID_CHANNEL";
    /**
     * PUSH - Push notification.
     */
    Channel["PUSH"] = "PUSH";
    /**
     * SMS - SMS notification.
     */
    Channel["SMS"] = "SMS";
    /**
     * EMAIL - Email notification.
     */
    Channel["EMAIL"] = "EMAIL";
    Channel["UNRECOGNIZED"] = "UNRECOGNIZED";
})(Channel || (exports.Channel = Channel = {}));
function createBaseNotificationFilter() {
    return {
        id: '',
        userId: '',
        destinationAddress: '',
        channel: Channel.INVALID_CHANNEL,
        created: undefined,
        sent: undefined,
        templateId: '',
        templateName: '',
    };
}
exports.NotificationFilter = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.id)) {
            message.id = globalThis.String(object.id);
        }
        if (isSet(object.userId)) {
            message.userId = globalThis.String(object.userId);
        }
        if (isSet(object.destinationAddress)) {
            message.destinationAddress = globalThis.String(object.destinationAddress);
        }
        if (isSet(object.channel)) {
            message.channel = channelFromJSON(object.channel);
        }
        if (isSet(object.created)) {
            message.created = exports.NotificationFilterDateRange.fromJSON(object.created);
        }
        if (isSet(object.sent)) {
            message.sent = exports.NotificationFilterDateRange.fromJSON(object.sent);
        }
        if (isSet(object.templateId)) {
            message.templateId = globalThis.String(object.templateId);
        }
        if (isSet(object.templateName)) {
            message.templateName = globalThis.String(object.templateName);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== undefined && message.id !== '') {
            obj.id = message.id;
        }
        if (message.userId !== undefined && message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.destinationAddress !== undefined && message.destinationAddress !== '') {
            obj.destinationAddress = message.destinationAddress;
        }
        if (message.channel !== undefined && message.channel !== Channel.INVALID_CHANNEL) {
            obj.channel = channelToJSON(message.channel);
        }
        if (message.created !== undefined) {
            obj.created = exports.NotificationFilterDateRange.toJSON(message.created);
        }
        if (message.sent !== undefined) {
            obj.sent = exports.NotificationFilterDateRange.toJSON(message.sent);
        }
        if (message.templateId !== undefined && message.templateId !== '') {
            obj.templateId = message.templateId;
        }
        if (message.templateName !== undefined && message.templateName !== '') {
            obj.templateName = message.templateName;
        }
        return obj;
    },
    create(base) {
        return exports.NotificationFilter.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseNotificationFilter();
        message.id = object.id ?? '';
        message.userId = object.userId ?? '';
        message.destinationAddress = object.destinationAddress ?? '';
        message.channel = object.channel ?? Channel.INVALID_CHANNEL;
        message.created = (object.created !== undefined && object.created !== null)
            ? exports.NotificationFilterDateRange.fromPartial(object.created)
            : undefined;
        message.sent = (object.sent !== undefined && object.sent !== null)
            ? exports.NotificationFilterDateRange.fromPartial(object.sent)
            : undefined;
        message.templateId = object.templateId ?? '';
        message.templateName = object.templateName ?? '';
        return message;
    },
};
function createBaseNotificationFilterDateRange() {
    return { minMs: '0', maxMs: '0' };
}
exports.NotificationFilterDateRange = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.minMs)) {
            message.minMs = globalThis.String(object.minMs);
        }
        if (isSet(object.maxMs)) {
            message.maxMs = globalThis.String(object.maxMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.minMs !== undefined && message.minMs !== '0') {
            obj.minMs = message.minMs;
        }
        if (message.maxMs !== undefined && message.maxMs !== '0') {
            obj.maxMs = message.maxMs;
        }
        return obj;
    },
    create(base) {
        return exports.NotificationFilterDateRange.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseNotificationFilterDateRange();
        message.minMs = object.minMs ?? '0';
        message.maxMs = object.maxMs ?? '0';
        return message;
    },
};
function createBaseNoOpRequest() {
    return { notification: notification_messages_1.Notification.fromPartial({}), channel: Channel.INVALID_CHANNEL };
}
exports.NoOpRequest = {
    fromJSON(object) {
        const message = {
            notification: isSet(object.notification)
                ? notification_messages_1.Notification.fromJSON(object.notification)
                : notification_messages_1.Notification.fromPartial({}),
            channel: isSet(object.channel) ? channelFromJSON(object.channel) : Channel.INVALID_CHANNEL,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.notification !== undefined) {
            obj.notification = notification_messages_1.Notification.toJSON(message.notification);
        }
        if (message.channel !== Channel.INVALID_CHANNEL) {
            obj.channel = channelToJSON(message.channel);
        }
        return obj;
    },
    create(base) {
        return exports.NoOpRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseNoOpRequest();
        message.notification = (object.notification !== undefined && object.notification !== null)
            ? notification_messages_1.Notification.fromPartial(object.notification)
            : notification_messages_1.Notification.fromPartial({});
        message.channel = object.channel ?? Channel.INVALID_CHANNEL;
        return message;
    },
};
function createBaseNoOpResponse() {
    return {};
}
exports.NoOpResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.NoOpResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseNoOpResponse();
        return message;
    },
};
function channelFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_CHANNEL':
            return Channel.INVALID_CHANNEL;
        case 1:
        case 'PUSH':
            return Channel.PUSH;
        case 2:
        case 'SMS':
            return Channel.SMS;
        case 3:
        case 'EMAIL':
            return Channel.EMAIL;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return Channel.UNRECOGNIZED;
    }
}
exports.channelFromJSON = channelFromJSON;
function channelToJSON(object) {
    switch (object) {
        case Channel.INVALID_CHANNEL:
            return 'INVALID_CHANNEL';
        case Channel.PUSH:
            return 'PUSH';
        case Channel.SMS:
            return 'SMS';
        case Channel.EMAIL:
            return 'EMAIL';
        case Channel.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.channelToJSON = channelToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=notification-model.js.map